export const integrationData = [
    {
        year: '2020',
        newEntries: 12500,
        citizenships: 8100,
    },
    {
        year: '2021',
        newEntries: 14200,
        citizenships: 9400,
    },
    {
        year: '2022',
        newEntries: 18500,
        citizenships: 11200,
    },
    {
        year: '2023',
        newEntries: 22100,
        citizenships: 13800,
    },
    {
        year: '2024',
        newEntries: 20500,
        citizenships: 16400,
    },
    {
        year: '2025',
        newEntries: 19800,
        citizenships: 19500,
    },
];
